import type { SmartOLTMapOdb, SmartOLTMapOnu, SmartOLTStatusKind } from "../../../services/smartolt.service.ts"

export type FaultKey = "online" | "los" | "power" | "other"
export type CoverageKey = "weak" | "strong"

export const FAULT_COLORS: Record<FaultKey, string> = {
  online: "#22c55e",
  los: "#911313",
  power: "#1545a5",
  other: "#b4954c",
}

export const COVERAGE_COLORS = {
  strong: "#22c55e",
  weak: "#dc2626",
  unknown: "#94a3b8",
}

export const ODB_COLOR = "#475569"

export function faultKey(kind: SmartOLTStatusKind | string | null | undefined): FaultKey {
  if (kind === "online" || kind === "los" || kind === "power") return kind
  return "other"
}

export function matchesSearch(row: { name?: string | null; sn?: string | null; onu_external_id?: string | null; olt_name?: string | null; zone_name?: string | null; odb_name?: string | null; address?: string | null; odb_id?: string | null }, search: string) {
  const q = search.trim().toLowerCase()
  if (!q) return true
  return [row.name, row.sn, row.onu_external_id, row.olt_name, row.zone_name, row.odb_name, row.address, row.odb_id]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .includes(q)
}

export function filterMapOnus(
  rows: SmartOLTMapOnu[],
  {
    search,
    faults,
    coverage,
    showCoverage,
  }: {
    search: string
    faults: Record<FaultKey, boolean>
    coverage: Record<CoverageKey, boolean>
    showCoverage: boolean
  },
) {
  return rows.filter((row) => {
    if (!matchesSearch(row, search)) return false
    if (!faults[faultKey(row.status_kind)]) return false
    if (showCoverage && row.signal_band && !coverage[row.signal_band]) return false
    return true
  })
}

export function filterMapOdbs(rows: SmartOLTMapOdb[], search: string) {
  return rows.filter((row) => matchesSearch(row, search))
}

export function markerColor(row: SmartOLTMapOnu, showCoverage: boolean) {
  if (showCoverage && row.status_kind === "online") {
    if (row.signal_band === "strong") return COVERAGE_COLORS.strong
    if (row.signal_band === "weak") return COVERAGE_COLORS.weak
    return COVERAGE_COLORS.unknown
  }
  return FAULT_COLORS[faultKey(row.status_kind)]
}

export function formatSignal(value?: number | null) {
  if (value == null || Number.isNaN(value)) return "—"
  return `${value} dBm`
}
